import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom'; // For web apps; use `useNavigation` for React Native

const PromotionLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate(); // useNavigation for React Native

  const handleLogin = (e) => {
    e.preventDefault();
    const payload = {
      email: email,
      password: password
    };

    axios.post('https://cacityofgod.pythonanywhere.com/citizen/login/', payload)
      .then(response=> {
        navigate('/promo'); // For web apps; use `navigation.navigate('Home')` for React Native
        console.log(response)
      })
      .catch(error => {
        console.log(error);
        alert('Login failed. Please check your credentials and try again.'); // For web apps; use `Alert.alert` for React Native
      });
  };

  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-grow flex items-center justify-center p-4 sm:p-6 lg:p-8">
        <div className="w-full max-w-xs sm:max-w-sm lg:max-w-md bg-white shadow-md rounded-lg p-6">
          <h2 className="text-2xl font-bold mb-6 text-center">Login With Your App Details</h2>
          <form onSubmit={handleLogin}>
            <div className="mb-4">
              <label htmlFor="email" className="block text-sm font-medium mb-1">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-400"
                required
              />
            </div>
            <div className="mb-6">
              <label htmlFor="password" className="block text-sm font-medium mb-1">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-gray-300 rounded-md py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-400"
                required
              />
            </div>
            <button
              type="submit"
              className="bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded-md w-full transition-colors duration-300"
            >
              Login
            </button>
            <div className="text-blue-500 text-sm sm:text-lg mt-6 text-center">
              Download devotional app and refer to take part in this promo
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PromotionLogin;
